/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ members: NonNullable<unknown>, teams: NonNullable<unknown> }} Project_Private_Chats_Exception_SummaryInputs */



/**
* | output |
* | --- |
* | "Besides project admins, these can see everyone's chats — members: {members}, teams: {teams}" |
*
* @param {Project_Private_Chats_Exception_SummaryInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const project_private_chats_exception_summary = /** @type {((inputs: Project_Private_Chats_Exception_SummaryInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Project_Private_Chats_Exception_SummaryInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Neben den Projekt-Admins dürfen die Chats aller Mitglieder sehen – Mitglieder: ${i?.members}, Teams: ${i?.teams}`)
	return /** @type {LocalizedString} */ (`Besides project admins, these can see everyone's chats — members: ${i?.members}, teams: ${i?.teams}`)
});